module.exports = __webpack_public_path__ + "05cbf3a6a82b5ee1ef5077b85ae7729c.svg";